import React, { useEffect, useState } from "react";
import { 
  Form, 
  Input, 
  Button, 
  Select, 
  message, 
  DatePicker, 
  InputNumber,
  Upload,
  Card,
  Row,
  Col,
  Space
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useAuth } from "../Context";
import { useNotification } from "../NotificationContext";
import { firestore, storage } from "../../firebase";
import { collection, addDoc, doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import moment from "moment";
import Title from "antd/es/typography/Title";

const { Option } = Select;
const { TextArea } = Input;

const AgregarEquipo = ({ equipo, sucursal, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const { currentUser } = useAuth();
  const openNotificationWithIcon = useNotification();

  useEffect(() => {
    if (equipo) {
      // Si estamos editando, llenar el formulario
      form.setFieldsValue({
        ...equipo,
        fechaCompra: equipo.fechaCompra ? moment(equipo.fechaCompra.toDate()) : null,
        fechaGarantia: equipo.fechaGarantia ? moment(equipo.fechaGarantia.toDate()) : null,
      });
    }
  }, [equipo, form]);

  const handleFinish = async (values) => {
    if (!sucursal) {
      message.error("Error: No se pudo obtener la sucursal");
      return;
    }

    setLoading(true);
    try {
      const equipoData = {
        ...values,
        fechaCompra: values.fechaCompra?.toDate() || null,
        fechaGarantia: values.fechaGarantia?.toDate() || null,
        sucursal,
        creadoEn: equipo ? equipo.creadoEn : new Date(),
        actualizadoEn: new Date(),
        creadoPor: equipo ? equipo.creadoPor : currentUser?.email || "",
        actualizadoPor: currentUser?.email || ""
      };

      if (equipo) {
        // Actualizar equipo existente
        await updateDoc(doc(firestore, `sucursal/${sucursal}/equipo/${equipo.id}`), equipoData);
        message.success("Equipo actualizado correctamente");
        openNotificationWithIcon("success", "Éxito", "El equipo se actualizó correctamente");
      } else {
        // Crear nuevo equipo
        await addDoc(collection(firestore, `sucursal/${sucursal}/equipo`), equipoData);
        message.success("Equipo registrado correctamente");
        openNotificationWithIcon("success", "Éxito", "El equipo se registró correctamente");
      }
      
      form.resetFields();
      if (onClose) onClose();
    } catch (error) {
      console.error("Error al guardar equipo:", error);
      message.error("Error al guardar el equipo");
      openNotificationWithIcon("error", "Error", "Hubo un problema al guardar el equipo");
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (file) => {
    if (!file) return;

    setUploading(true);
    try {
      const storageRef = ref(storage, `equipos/${sucursal}/${Date.now()}_${file.name}`);
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      form.setFieldsValue({ imagenUrl: downloadURL });
      message.success("Imagen subida correctamente");
    } catch (error) {
      console.error("Error al subir imagen:", error);
      message.error("Error al subir la imagen");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <Title level={3} className="ccg-center">
        Registrar Equipo
      </Title>
      <Form
        form={form}
        style={{ maxWidth: 600, margin: "auto", textAlign: "center" }}
        onFinish={handleFinish}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item name="nombre" label="Nombre" rules={[{ required: true, message: "Por favor ingrese el nombre" }]}>
          <Input placeholder="Nombre del equipo" />
        </Form.Item>
        <Form.Item name="tipo" label="Tipo" rules={[{ required: true, message: "Por favor seleccione el tipo" }]}>
          <Select placeholder="Tipo de equipo">
            <Option value="vehiculo">Vehículo</Option>
            <Option value="maquinaria">Maquinaria</Option>
            <Option value="herramienta">Herramienta</Option>
            <Option value="otro">Otro</Option>
          </Select>
        </Form.Item>
        <Form.Item name="marca" label="Marca">
          <Input placeholder="Marca" />
        </Form.Item>
        <Form.Item name="modelo" label="Modelo">
          <Input placeholder="Modelo" />
        </Form.Item>
        <Form.Item name="serie" label="Serie">
          <Input placeholder="Serie" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Registrar Equipo
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default AgregarEquipo;
